import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isBoolean, oneOf } from './type-guards';
/**
 * Helper to create a boolean experiment configuration
 */
export function createBooleanExperiment(config) {
  return _objectSpread(_objectSpread({}, config), {}, {
    typeGuard: isBoolean,
    defaultValue: config.defaultValue
  });
}

/**
 * Helper to create a multivariate experiment configuration
 */
export function createMultivariateExperiment(config) {
  var values = config.values;
  return _objectSpread(_objectSpread({}, config), {}, {
    values: _toConsumableArray(values),
    // Maintains the tuple
    typeGuard: oneOf(config.values),
    defaultValue: config.defaultValue
  });
}